<ng-container miqStopClick>
  <ng-content></ng-content>
  <a
    [attr.href]="disabled ? null : href"
    [target]="targetAnchor"
    rel="noopener noreferrer"
    [class]="classes"
    [class.disabled]="disabled"
    [attr.aria-disabled]="disabled || null"
    [matTooltipDisabled]="!toolTipMessage"
    [matTooltip]="toolTipMessage"
    [matTooltipPosition]="toolTipPosition"
    miqStopClick
  >
    <mat-icon class="icon" [svgIcon]="svgIconName"></mat-icon>
  </a>
</ng-container>
